import React from 'react';

const ROLES = [
  { value: '', label: 'e.g. Web Developer, Data Analyst…' },
  { value: 'Web Developer', label: 'Web Developer' },
  { value: 'Data Analyst', label: 'Data Analyst' },
  { value: 'Full Stack Engineer', label: 'Full Stack Engineer' },
  { value: 'UI/UX Designer', label: 'UI/UX Designer' },
  { value: 'DevOps Engineer', label: 'DevOps Engineer' },
  { value: 'Product Manager', label: 'Product Manager' },
  { value: 'Software Engineer', label: 'Software Engineer' },
  { value: 'Frontend Developer', label: 'Frontend Developer' },
  { value: 'Backend Developer', label: 'Backend Developer' },
  { value: 'Full Stack Developer', label: 'Full Stack Developer' },
  { value: 'Data Scientist', label: 'Data Scientist' },
  { value: 'Machine Learning Engineer', label: 'Machine Learning Engineer' },
  { value: 'AI Engineer', label: 'AI Engineer' },
  { value: 'Cyber Security Engineer', label: 'Cyber Security Engineer' },
  { value: 'Network Engineer', label: 'Network Engineer' },
];

export default function RoleSelector({ value, onChange }) {
  return (
    <div style={styles.wrapper}>
      <select
        id="role-selector"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="role-select-field"
        aria-label="Select target job role"
      >
        {ROLES.map((role) => (
          <option key={role.value === '' ? 'placeholder' : role.value} value={role.value}>
            {role.label}
          </option>
        ))}
      </select>
      <span style={styles.chevron} aria-hidden="true">
        ▾
      </span>
    </div>
  );
}

const styles = {
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  chevron: {
    position: 'absolute',
    right: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#6b6b6b',
    pointerEvents: 'none',
    fontSize: '1.05rem',
  },
};
